//
// Copyright 2026 DXOS.org
//
import * as Context from 'effect/Context';
import * as Rpc from 'effect/rpc/Rpc';
import * as RpcGroup from 'effect/rpc/RpcGroup';
import * as Schema from 'effect/Schema';
import { DeviceSchema } from './buf/proto/gen/dxos/client/services_pb.js';
import { DeviceProfileDocumentSchema } from './buf/proto/gen/dxos/halo/credentials_pb.js';
import { bufMessage, serviceError } from './service-rpc.js';
import { mutableArray } from './service-schemas.js';
//
// RPC message schemas.
//
export const QueryDevicesResponse = Schema.Struct({
    devices: Schema.optional(mutableArray(bufMessage(DeviceSchema))),
});
/**
 * Effect RPC definitions for `dxos.client.services.DevicesService`.
 * Service-only payloads use Effect schemas; shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('updateDevice', {
    payload: bufMessage(DeviceProfileDocumentSchema),
    success: bufMessage(DeviceSchema),
    error: serviceError,
}), Rpc.make('queryDevices', {
    success: QueryDevicesResponse,
    error: serviceError,
    stream: true,
})).prefix('DevicesService.') {
}
/**
 * Effect service tag for the `DevicesService` RPC handlers.
 */
export class Tag extends Context.Service()('@dxos/protocols/rpc/DevicesService') {
}
//# sourceMappingURL=DevicesService.js.map